import styled from 'styled-components';
import Footer from '../components/footer/Footer';
import { useEffect, useState } from 'react';
import PageTop from '../components/pageTop/PageTop';
import History from './components/History';
import Carousel2Browser from './components/Carousel2_2';

const serviceInfo = [
  {
    title: '위치 기반으로 보는 투자 기회,<br/>실거래가까지 한눈에',
    content:
      '원하는 지역의 경매 물건을 지도에서 바로 찾아보세요.<br/>실거래가 정보와 함께 표시되어 투자 가치 분석이<br/>한결 쉬워집니다.<br/>지역 특성부터 시세 동향까지 비교하며 최적의 투자<br/>기회를 발견하세요.',
    image: 'assets/images/companyInfo/serviceInfo_1.png',
    backgroundColor: '#FFF3F9',
  },
  {
    title: '한눈에 보는 경매 물건 분석 리포트',
    content:
      '권리분석, 입찰분석, 예상수익률까지.<br/>투자 의사결정에 핵심적인 데이터를<br/>한 페이지에 담았습니다.<br/>땅집고옥션의 상세 분석 리포트로<br/>투자의 불확실성을 줄이고<br/>기회는 높이세요.',
    image: 'assets/images/companyInfo/serviceInfo_2.png',
    backgroundColor: '#ECFBE8',
  },
  {
    title: '위치 기반으로 보는 투자 기회,<br/>실거래가까지 한눈에',
    content:
      '원하는 지역의 경매 물건을 지도에서 바로 찾아보세요.<br/>실거래가 정보와 함께 표시되어 투자 가치 분석이<br/>한결 쉬워집니다.<br/>지역 특성부터 시세 동향까지 비교하며 최적의 투자<br/>기회를 발견하세요.',
    image: 'assets/images/companyInfo/serviceInfo_3.png',
    backgroundColor: '#FFF4E9',
  },
];

const CompanyInfo = () => {
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <Container>
      <PageTop text="회사소개" />
      <img
        src="assets/images/companyInfo/companyInfo_1.png"
        alt="companyInfo_1"
        style={{
          width: '100%',
        }}
      />
      <Content1Wrapper>
        <RoundDivider></RoundDivider>
        <Content1Box>
          <img src="/assets/images/companyInfo/companyInfo_2.png" alt="" />
          <div>
            부동산 투자 디지털 허브
            <span>땅집고옥션</span>
          </div>
        </Content1Box>
        <CompanyInfoBox>
          <Top>
            <Left>
              <span>
                <span style={{ color: '#008AFF' }}>똑똑한 투자생활</span>을 위한
                <br />
                땅집고옥션 활용 가이드
              </span>
            </Left>
            <Right>
              <div
                style={{
                  fontSize: '18px',
                  fontWeight: '700',
                  color: '#222222',
                }}
              >
                맞춤형 검색으로 더 현명한 경매 투자
              </div>
              <div>
                다양한 검색 필터로 경매 물건을 쉽게 찾아보세요.
                <br /> 상세 조건별 필터링으로 원하는 조건의 매물만 골라보고,
                <br />
                실시간으로 업데이트되는 정보를 놓치지 마세요.
              </div>
            </Right>
          </Top>
          <img
            src="/assets/images/companyInfo/companyInfo_3.png"
            alt=""
            style={{ marginTop: '40px' }}
          />
        </CompanyInfoBox>
        {serviceInfo.map((item, index) => (
          <ServiceInfo
            key={index}
            style={{ backgroundColor: item.backgroundColor }}
          >
            <Description>
              <TitleSpan dangerouslySetInnerHTML={{ __html: item.title }} />
              <ContentSpan dangerouslySetInnerHTML={{ __html: item.content }} />
            </Description>
            <Img src={`${item.image}`} alt="" />
          </ServiceInfo>
        ))}
      </Content1Wrapper>
      {/* <TeamLeaderBox>
        <TeamLeaderTitle>Team Leader</TeamLeaderTitle>
        <Carousel2Browser></Carousel2Browser>
      </TeamLeaderBox> */}
      <History />
      <Footer />
    </Container>
  );
};

export default CompanyInfo;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Content1Wrapper = styled.div`
  width: 100%;
  position: relative;
  background-color: #fff;
`;

const RoundDivider = styled.div`
  position: absolute;
  top: -24px;
  width: 100%;
  height: 24px;
  background-color: #fff;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
`;

const Content1Box = styled.div`
  width: 100%;
  padding: 56px 0px 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  color: #222222;
  font-size: 24px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  span {
    color: #008aff;
  }
`;

const CompanyInfoBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 80px 16px;
  background-color: #ecf6ff;
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const Left = styled.div`
  font-size: 24px;
  font-weight: 700;
`;

const Right = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ServiceInfo = styled.div`
  padding: 80px 16px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TitleSpan = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #222222;
`;

const ContentSpan = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  margin-top: 40px;
`;

const TeamLeaderTitle = styled.div`
  width: 100%;
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`;

const TeamLeaderBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  gap: 48px;
`;
